import { SESSION_STORAGE_KEYS } from '@constants/constants';
import { SessionStorage } from '@utils/storage';

/** "board_and_abstract-strategy" / "CASUAL" → "Board And Abstract Strategy" / "Casual" */
const toTitleCase = (value: string) =>
  value
    .trim()
    .replace(/[_-]+/g, ' ')
    .toLowerCase()
    .replace(/(^|\s)\S/g, (char) => char.toUpperCase());

/** The category and genre picked on the website, stored by the /redirect page, if both exist. */
const getPickedReport = (): { category: string; genre: string } | null => {
  const category = SessionStorage.getItem(SESSION_STORAGE_KEYS.MARKET_SCANNER_CATEGORY);
  const genre = SessionStorage.getItem(SESSION_STORAGE_KEYS.MARKET_SCANNER_GENRE);
  if (!category?.trim() || !genre?.trim()) return null;

  return { category: toTitleCase(category), genre: toTitleCase(genre) };
};

export default getPickedReport;
